// Preparado para integração futura de analytics.
// Eventos: hero_cta_click, demo_click, whatsapp_click, instagram_click,
// restaurant_lead, network_lead, video_play, video_complete.

type AnalyticsData = Record<string, unknown>;

export function track(event: string, data?: AnalyticsData) {
  if (typeof window === "undefined") return;
  const w = window as unknown as {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: AnalyticsData[];
    fbq?: (...args: unknown[]) => void;
  };

  try {
    if (typeof w.gtag === "function") w.gtag("event", event, data);
    if (Array.isArray(w.dataLayer)) w.dataLayer.push({ event, ...data });
    if (typeof w.fbq === "function") w.fbq("track", event, data);
  } catch {
    /* analytics não configurado — ignora silenciosamente */
  }
}